// extracted by mini-css-extract-plugin
module.exports = {"row":"GroupSelector_row__bnajV","text":"GroupSelector_text__38wLR","group":"GroupSelector_group__2ftxI"};